/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 414);
/******/ })
/************************************************************************/
/******/ ({

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(415);

__webpack_require__(416);

function bootstrap() {
    var page = '';
    var formStatus = false;
    var autoFillInterval = void 0;

    var input = {
        username: document.querySelector('input[name=\'username\']'),
        email: document.querySelector('input[name=\'email\']'),
        password: document.querySelector('input[name=\'password\']'),
        password_confirmation: document.querySelector('input[name=\'password_confirmation\']'),
        submit: document.querySelector('input[type=\'submit\']')
    };

    var inputsByPage = {
        login: {
            username: input.username,
            password: input.password
        },
        passwordReset: {
            email: input.email
        },
        passwordSetNew: {
            username: input.username,
            password: input.password,
            passwordConfirmation: input.password_confirmation
        },
        changePassword: {
            password: input.password,
            passwordConfirmation: input.password_confirmation
        }
    };

    /* Functions */

    function checkLoginForm() {
        var completedFields = 0;
        var i = 0;

        Object.keys(inputsByPage[page]).forEach(function (name) {
            i++;

            var el = inputsByPage[page][name];

            if (!el.value) {
                return;
            }

            completedFields++;
        });

        // Password Set New & Change Password - password fields must match
        if (page === 'passwordSetNew' && completedFields === 3 || page === 'changePassword' && completedFields === 2) {
            var passwordsNonMatching = document.getElementById('password-non-matching');

            if (inputsByPage[page].password.value !== inputsByPage[page].passwordConfirmation.value) {
                formStatus = false;
                passwordsNonMatching.classList.add('show');
                return;
            }

            passwordsNonMatching.classList.remove('show');
        }

        formStatus = completedFields === i;
    }

    function enableSubmitButton() {
        checkLoginForm();

        var submitButton = input.submit;

        if (page !== 'login' && !formStatus) {
            submitButton.setAttribute('disabled', 'true');
            submitButton.classList.remove('active');

            return;
        }

        submitButton.removeAttribute('disabled');
        submitButton.classList.add('active');
    }

    function checkForAutoFill() {
        var i = 0;

        autoFillInterval = setInterval(function () {
            ++i;

            enableSubmitButton();

            if (formStatus || i >= 50) {
                clearInterval(autoFillInterval);
            }
        }, 100);
    }

    function setCurrentPage() {
        switch (document.getElementById('main').getAttribute('data-page').trim()) {
            case 'password-reset':
                page = 'passwordReset';
                break;
            case 'password-set-new':
                page = 'passwordSetNew';
                break;
            case 'change-password':
                page = 'changePassword';
                break;
            default:
                // login
                page = 'login';
        }
    }

    function reloadRoot() {
        window.location.href = '/';
    }

    function forEach(array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    }

    setCurrentPage();

    /* Set focus */

    switch (page) {
        case 'passwordReset':
            // case 'passwordSetNew':
            inputsByPage[page].email.focus();
            break;
        case 'changePassword':
            inputsByPage[page].password.focus();
            break;
        default:
            // login
            inputsByPage[page].username.focus();
    }

    /* Prompt Form Validation */

    var nodeList = document.querySelectorAll('input');

    forEach(nodeList, function (i, el) {
        el.onkeyup = enableSubmitButton;
    });

    /* Init */

    enableSubmitButton();
    checkForAutoFill();

    /* Reload page after 119 minutes to prevent session timeout */
    window.setTimeout(reloadRoot, 7140000);
}

document.addEventListener('DOMContentLoaded', bootstrap);

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// login.c625d0e693ad16f5b3ce.js